<section class="no-padding" *ngIf="canShowPerformanceCommentary$ | async; else errorPerformanceCommentary">
	<mb-performance-commentary-text *componentId="[{ componentId: 'me.family.performance.commentary', ids: familyIds }]; let res" [data]="res"></mb-performance-commentary-text>
	<ac-disclosure dcrKey="PERFORMANCE_COMMENTARY_DISCLOSURE" [isExpandable]="false"></ac-disclosure>
</section>

<ng-template #errorPerformanceCommentary>
	<div *ngIf="(canShowPerformanceCommentary$ | async) === false" dcrHTMLKey="PERFORMANCE_COMMENTARY_ERROR">
		Performance commentary is not available for this model family due to an issue with performance data
	</div>
</ng-template>
